<template>
    <inline-tab-panel name="objects">
        <flex-container>
            <flex-container :gap="Size.sm" align-items="center">
                <text-heading>
                    Objecten
                </text-heading>

                <chip-informative :color="'primary'">
                    {{ props.wonenObjecten.length }}
                </chip-informative>
            </flex-container>

            <card-normal without-padding>
                <list-container>
                    <template #header>
                        <list-cell-header>
                            <template #title>
                                Adres
                            </template>
                        </list-cell-header>
                        <list-cell-header>
                            <template #title>
                                Type
                            </template>
                        </list-cell-header>
                        <list-cell-header>
                            <template #title>
                                Bouwjaar
                            </template>
                        </list-cell-header>
                        <list-cell-header>
                            <template #title>
                                Soort
                            </template>
                        </list-cell-header>
                        <list-cell-header>
                            <template #title>
                                Status
                            </template>
                        </list-cell-header>
                        <list-cell-header />
                    </template>

                    <template #content>
                        <list-row v-if="props.wonenObjecten.length === 0">
                            <list-cell-text colspan="6">
                                <template #content>
                                    Er zijn geen objecten voor dit contact
                                </template>
                            </list-cell-text>
                        </list-row>
                        <list-row
                            v-for="(object, index) in props.wonenObjecten"
                            :key="object.id"
                            :background-color="index % 2 ? 'gray-100' : 'white'"
                        >
                            <list-cell-text>
                                <template #content>
                                    {{ object.straat }} {{ object.huisnummer }}{{ object.huisnummertoevoeging }},
                                    {{ object.postcode }} {{ object.plaats }}
                                </template>
                            </list-cell-text>
                            <list-cell-text>
                                <template #content>
                                    {{ object.bouwvorm }}
                                </template>
                            </list-cell-text>
                            <list-cell-text>
                                <template #content>
                                    {{ object.bouwjaar }}
                                </template>
                            </list-cell-text>
                            <list-cell-text>
                                <template #content>
                                    {{ object.woonhuistype }}
                                </template>
                            </list-cell-text>
                            <list-cell-text>
                                <template #content>
                                    {{ object.actief }} ????
                                </template>
                            </list-cell-text>
                            <list-cell-text />
                        </list-row>
                    </template>
                </list-container>
            </card-normal>
        </flex-container>
    </inline-tab-panel>
</template>

<script setup lang="ts">
    import { ListRow, Size } from '@keyvue/one-ui';
    import type { RealworksWonenObject } from '@keyvue/one-api-client-legacy';

    const props = defineProps<{
        wonenObjecten: RealworksWonenObject[]
    }>();
</script>
